import { makeAutoObservable, observable, runInAction, action } from "mobx";

export class ItemPreviewHoveringState {
  hovering = false;
  hoveredRect: DOMRect | null = null;
  onHoverActivate?: () => void;

  constructor() {
    makeAutoObservable(this, {
      hovering: observable,
      setHoveredRect: action,
    });
  }

  private hoveringDelayed = false;
  private timeoutHandle = 0;

  setHoveredRect(rect: DOMRect | null) {
    this.hoveredRect = rect;
  }

  setHoveringDelayed = (hovering: boolean) => {
    if (this.hoveringDelayed === hovering) {
      return;
    }

    clearTimeout(this.timeoutHandle);
    this.hoveringDelayed = hovering;
    this.timeoutHandle = window.setTimeout(() => {
      runInAction(() => {
        const wasHovering = this.hovering;
        this.hovering = this.hoveringDelayed;
        if (!wasHovering && this.hovering) {
          this.onHoverActivate?.();
        }
      });
    }, 300);
  };

  handleMouseLeave = () => {
    this.setHoveringDelayed(false);
  };

  handleMouseEnter = () => {
    this.setHoveringDelayed(true);
  };
}
